import { createAsyncThunk } from '@reduxjs/toolkit';
import MarketplaceSuppliersResource from 'api/service/MarketplaceSuppliersResource';
import { listProducts } from './marketplace-products';

export const listSuppliers = createAsyncThunk(
  'marketplaceManagement/listSuppliers',
  async (initialData, { rejectWithValue }) => {
    const marketplaceSuppliersResource = new MarketplaceSuppliersResource();
    const { offset = 0, query = '' } = initialData || {};
    const response = await marketplaceSuppliersResource.list({
      size: 10,
      includes: 'product_count,shared_count',
      search: query || '',
      offset,
    });

    if (response?.status === 200) {
      return { data: response?.data || [], offset: 10 + offset };
    }
    return rejectWithValue('Suppliers not found');
  }
);

export const listSuppliersNext = createAsyncThunk(
  'marketplaceManagement/listSuppliersNext',
  async (initialData, { rejectWithValue }) => {
    const marketplaceSuppliersResource = new MarketplaceSuppliersResource();
    const { offset = 0, query = '' } = initialData || {};
    const response = await marketplaceSuppliersResource.list({
      size: 10,
      includes: 'product_count,shared_count',
      search: query || '',
      offset,
    });

    if (response?.status === 200) {
      return { data: response?.data || [], offset: 10 + offset };
    }
    return rejectWithValue('Suppliers not found');
  }
);

export const listOptionSuppliers = createAsyncThunk(
  'marketplaceManagement/listOptionSuppliers',
  async (_, { rejectWithValue }) => {
    const marketplaceSuppliersResource = new MarketplaceSuppliersResource();
    const { status, data } = await marketplaceSuppliersResource.list({ size: 100, offset: 0 });
    if (status === 200) {
      return data;
    }
    return rejectWithValue('Suppliers not found');
  }
);

export const createSupplier = createAsyncThunk(
  'marketplaceManagement/createSupplier',
  async (initialData, { rejectWithValue }) => {
    const marketplaceSuppliersResource = new MarketplaceSuppliersResource();
    const { supplier } = initialData;
    const { address, suburb, state, postcode } = supplier.address;
    const hasAddress = supplier?.address && address && suburb && state && postcode;
    const supplierData = {
      name: supplier?.name,
      contact: {
        name: supplier?.contact,
        email: supplier?.email,
        phone: supplier?.phone,
        ...(hasAddress && { address: supplier?.address }),
      },
    };
    const { status, data } = await marketplaceSuppliersResource.create(supplierData);
    if (status === 201) {
      return data;
    }
    return rejectWithValue('Supplier creation failed.');
  }
);

export const updateSupplier = createAsyncThunk(
  'marketplaceManagement/updateSupplier',
  async (initialData, { rejectWithValue, dispatch }) => {
    const marketplaceSuppliersResource = new MarketplaceSuppliersResource();
    const { supplier } = initialData;
    const { address, suburb, state, postcode } = supplier.address;
    const hasAddress = supplier?.address && address && suburb && state && postcode;
    const supplierData = {
      name: supplier?.name,
      contact: {
        name: supplier?.contact,
        email: supplier?.email,
        phone: supplier?.phone,
        ...(hasAddress && { address: supplier?.address }),
      },
    };
    const { status, data } = await marketplaceSuppliersResource.supplier(supplier.id).update(supplierData);
    if (status === 200) {
      dispatch(listProducts());
      return data;
    }
    return rejectWithValue('Supplier updating failed.');
  }
);

export const deleteSupplier = createAsyncThunk(
  'marketplaceManagement/deleteSupplier',
  async (initialData, { rejectWithValue }) => {
    const marketplaceSuppliersResource = new MarketplaceSuppliersResource();
    const { id } = initialData;
    const { status } = await marketplaceSuppliersResource.supplier(id).delete();
    if (status === 202) {
      return id;
    }
    return rejectWithValue('Supplier deletion failed.');
  }
);
